import React from 'react';
import { Box, Text, Icon } from '@chakra-ui/react';
import { FaImage } from 'react-icons/fa';

const Placeholder = ({ 
  width = "100%", 
  height = "300px", 
  text = "Image", 
  icon = FaImage,
  bg = "gray.100",
  iconColor = "gray.400",
  borderRadius = "xl"
}) => {
  return (
    <Box
      width={width}
      height={height}
      bg={bg}
      borderRadius={borderRadius}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      _dark={{
        bg: 'gray.700',
      }}
    >
      <Icon 
        as={icon} 
        boxSize={12} 
        color={iconColor}
        _dark={{
          color: 'gray.500',
        }}
      />
      <Text
        mt={2}
        fontSize="sm"
        color="gray.500"
        _dark={{
          color: 'gray.400',
        }}
      >
        {text}
      </Text>
    </Box>
  );
};

export default Placeholder;
